import { useRef } from "react";
export function useSectionRefs() {
    const sectionRefs = useRef({});
    const setSectionRef = (sectionId) => (el) => {
        sectionRefs.current[sectionId] = el;
    };
    return { sectionRefs, setSectionRef };
}
